import { twMerge } from 'tailwind-merge'
import { IconCounter } from '../../icon-counter/icon-counter'
import { DetailsTableDataGroup } from '../models'

export interface DataGroupIconCounterProps {
  isFirstGroup?: boolean
}

export function DataGroupIconCounter({
  labelClassName,
  label,
  valueClassName,
  value,
  isFirstGroup,
  icon,
  iconCount,
}: DataGroupIconCounterProps & DetailsTableDataGroup) {
  return (
    <>
      {icon ? <IconCounter icon={icon} count={iconCount} className="text-primary" /> : null}
      <div
        data-testid="dataGroupIconCounter"
        className={twMerge(`pt-[10px] text-[14px] font-bold leading-none`, !isFirstGroup ? 'pt-6' : '', labelClassName)}
      >
        {label}
      </div>
      {value ? <div className={twMerge(`pt-[10px] text-[14px] md:truncate`, valueClassName)}>{value}</div> : null}
    </>
  )
}
